





import { defineComponent } from '@vue/composition-api';

import PanelWithVoteEditor from '@/components/Live/PanelWithVoteEditor.vue';

const New = defineComponent({
  components: {
    PanelWithVoteEditor,
  },
  // setup() {},
});

export default New;
